/* eslint-disable react-refresh/only-export-components */
import { Route, BrowserRouter, Routes, Navigate } from "react-router-dom"
import { AdminRoutes, AgencyRoutes } from "./routes"
import NotFound from "./components/NotFound"
import "./App.css"
import AdminNavBar from "./components/Navbar/AdminNavBar"
import AgencyNavBar from "./components/Navbar/AgencyNavBar"
import { useSelector } from "react-redux"
import { useEffect } from "react"
import ForgotPassword from "./pages/Agency/ForgotPassword"
import ResetPassword from "./pages/Agency/ResetPassword"
import CompleteRegistration from "./pages/Agency/CompleteRegistration"
import * as Sentry from "@sentry/react"
import useTokenRefresher from "./constant/useTokenRefresher"

const App = () => {
    const site = window.sessionStorage.getItem("site")
    const currentPath = window.location.pathname
    const isRootLevel = currentPath === "/"
    const isAdminURL = currentPath.includes("/admin")
    const isAgencyURL = currentPath.includes("/agency")
    const { isAuthenticated } = useSelector((state) => state.authentication)
    const { initRefreshToken } = useTokenRefresher()

    useEffect(() => {
        if (isAdminURL && site !== "admin") {
            window.sessionStorage.removeItem("site")
            window.sessionStorage.removeItem("ACCESS_TOKEN")
        } else if (isAgencyURL && site !== "agency") {
            window.sessionStorage.removeItem("site")
            window.sessionStorage.removeItem("ACCESS_TOKEN")
        }

        initRefreshToken()
    }, [])

    return (
        <Sentry.ErrorBoundary>
            <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
                {isAuthenticated ? (
                    isAdminURL ? (
                        <AdminNavBar />
                    ) : isAgencyURL || isRootLevel ? (
                        <AgencyNavBar />
                    ) : null
                ) : null}
                <Routes>
                    <Route
                        path="/agency"
                        element={
                            <Navigate
                                to="/agency/dashboard"
                                replace
                            />
                        }
                    />
                    <Route
                        path="/agency/*"
                        element={<AgencyRoutes site={site} />}
                    />
                    <Route
                        path="/admin/*"
                        element={<AdminRoutes site={site} />}
                    />
                    <Route
                        path="/"
                        element={<AgencyRoutes site={site} />}
                    />
                    <Route
                        path="/forgot-password"
                        element={<ForgotPassword />}
                    />
                    <Route
                        path="/reset-password/*"
                        element={<ResetPassword />}
                    />
                    <Route
                        path="/complete-registration/*"
                        element={<CompleteRegistration />}
                    />
                    <Route
                        path="*"
                        element={<NotFound />}
                    />
                </Routes>
            </BrowserRouter>
        </Sentry.ErrorBoundary>
    )
}

export default App
